import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { PeremrillojiParametri, PeremriNumri, PeremriRasa, PronoriLloji } from '@core/enums/peremri/peremri.enum';
import { PeremriConstants } from '@core/globals/peremri/peremri-constants';
import { PeremriForCreationDTO } from '@core/interfaces/dto/peremri-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { PeremriPronorFormulaService } from './peremri-pronor-formula.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriPronorService {


  constructor(
    private fb: UntypedFormBuilder,
    private peremriPronorFormulaService: PeremriPronorFormulaService,
  ) { }

  insertForms(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {
    const formArray = form.get('peremriBaza.peremriPronor') as UntypedFormArray;
    this.generatePronoreForms(formArray, manual);
    peremriBaza.peremri?.forEach((item) => {
      let index = formArray.controls.findIndex(
        (c) =>
          c.get('pronoriLlojiId')?.value == item.pronoriLlojiId &&
          c.get('gjiniaId')?.value == item.gjiniaId &&
          c.get('numriId')?.value == item.numriId &&
          c.get('rasaId')?.value == item.rasaId &&
          c.get('pershkrimi')?.value == ''
      );
      if (index != -1) {
        formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
      } else {
        this.addNewLakimi(form, item.pronoriLlojiId, item.gjiniaId, item.numriId, item.rasaId, item.pershkrimi);
      }
    });
  }

  generateForms(form: UntypedFormGroup, manual: boolean) {
    this.generatePronoreForms(form.get('peremriBaza.peremriPronor') as UntypedFormArray, manual);
  }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    let formArray = form.get('peremriBaza.peremriPronor') as UntypedFormArray;
    this.peremriPronorFormulaService.generateFormula(peremriLlojiParametri, formArray);
  }

  generatePronoreForms(formArray: UntypedFormArray, manual: boolean) {

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    for (const pl of PeremriConstants.PronoriLloji) {
      for (const pgj of PeremriConstants.PeremriGjinite) {
        for (const pn of PeremriConstants.PeremriNumri) {
          for (const pr of PeremriConstants.PeremriRasat) {
            const peremriForm = this.fb.group({
              pronoriLlojiId: pl.id,
              gjiniaId: pgj.id,
              numriId: pn.id,
              rasaId: pr.id,
              pershkrimi: '',
            });

            formArray.push(peremriForm);
          }
        }
      }
    }

    if (!manual) formArray.disable();
  }

  addNewLakimi(form: UntypedFormGroup, pronoriLloji: number | null, gjinia: number | null, numri: PeremriNumri | null, rasa: PeremriRasa | null, pershkrimi?: string) {
    const formArray = <UntypedFormArray>form.get('peremriBaza.peremriPronor');
    const peremriForm = this.fb.group({
      pronoriLlojiId: pronoriLloji,
      gjiniaId: gjinia,
      numriId: numri,
      rasaId: rasa,
      pershkrimi: pershkrimi
    });
    formArray.push(peremriForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: PeremriForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('peremriBaza.peremriPronor') as UntypedFormArray;

    formArray.value.forEach((p: any) => {
      creationDTO.push({
        pronoriLlojiId: p.pronoriLlojiId,
        gjiniaId: p.gjiniaId,
        numriId: p.numriId,
        rasaId: p.rasaId,
        pershkrimi: p.pershkrimi
      })
    })
    return creationDTO;
  }
}
